@if (
  this.selectAdditionalTimeSeriesNames();
  as allAvailableAdditionalTimeSeriesNames
) {
  <pm-form-field label="RESULT.SIDEBAR.ADDITIONAL_TIME_SERIES">
    <pm-form-input-select
      [data]="
        allAvailableAdditionalTimeSeriesNames | pmArrayToSelectFieldOption
      "
      [allowSelectAll]="true"
      [multiSelect]="true"
      [clearable]="true"
      [allowUnselect]="true"
      [formControl]="timepickerControl"
      [disabled]="this.isPending()"
    />
  </pm-form-field>
}
